import HexaItem from './HexaItem';

module.exports = {
  HexaItem
};



// WEBPACK FOOTER //
// ./src/ui/Views/Article/CardItems/index.js